import { Action, createReducer, on } from '@ngrx/store';
import { goHomeSuccessAction, logoutSuccessAction } from '@symphony-solo/domain/authentication/src';
import { authenticateLocationSuccessAction } from '@symphony-solo/domain/location/src';
import { TransactionProduct } from '../models';
import {
  addProductInTransactionAction,
  clearTransactionInformationAction,
  clearTransactionReceiptAction,
  createTransactionAction,
  loadTransactionReceiptAction,
  loadTransactionReceiptErrorAction,
  loadTransactionReceiptSuccessAction,
  removeAllProductsFromTransactionAction,
  removeProductFromTransactionAction,
  submitTransactionAction,
  submitTransactionErrorAction,
  submitTransactionSuccessAction,
} from './transaction.actions';
import { TransactionState } from './transaction.state';

const initialState = new TransactionState();

const reducer = createReducer(
  initialState,
  on(addProductInTransactionAction, (state, payload) => {
    const newState = { ...state };
    newState.products = [...state.products, { ...payload.product, lineNo: state.products.length + 1 }];
    return newState;
  }),
  on(removeProductFromTransactionAction, (state, payload) => {
    const newState = { ...state };

    newState.products = state.products.map((product) => {
      if (product.lineNo === payload.productLineNo) {
        return { ...product, lineIsCorrected: true };
      }
      return product;
    });

    return newState;
  }),
  on(removeAllProductsFromTransactionAction, (state) => {
    const newState = { ...state };
    newState.isDeletingInProgress = true;
    return newState;
  }),
  on(authenticateLocationSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.transactionId = payload.locationResponse.transactionID;
    return newState;
  }),
  on(createTransactionAction, (state, payload) => {
    const newState = { ...state };
    newState.transactionFlowType = payload.transactionFlow;
    return newState;
  }),
  on(submitTransactionAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(submitTransactionSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.wordOfTheDay = payload.wordOfTheDay;
    newState.isDeletingInProgress = false;
    return newState;
  }),
  on(submitTransactionErrorAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.transactionFlowType = null;
    newState.isDeletingInProgress = false;
    return newState;
  }),
  on(clearTransactionInformationAction, (state) => {
    // todo: reuse this logic for logoutSuccess and goHomeSuccess
    const newState = { ...state };
    newState.transactionFlowType = null;
    newState.products = new Array<TransactionProduct>();
    return newState;
  }),
  on(logoutSuccessAction, (state) => {
    const newState = { ...state };
    newState.transactionId = null;
    newState.products = new Array<TransactionProduct>();
    newState.wordOfTheDay = null;
    newState.transactionFlowType = null;
    newState.failures = null;
    newState.isDeletingInProgress = false;

    return newState;
  }),
  on(goHomeSuccessAction, (state) => {
    const newState = { ...state };
    newState.transactionId = null;
    newState.products = new Array<TransactionProduct>();
    newState.wordOfTheDay = null;
    newState.transactionFlowType = null;
    newState.failures = null;
    newState.isDeletingInProgress = false;

    return newState;
  }),
  on(loadTransactionReceiptAction, (state, payload) => {
    const newState = { ...state };
    newState.transactionId = payload.transactionId;
    newState.transactionReceipt = null;
    newState.isLoading = true;
    newState.failures = null;
    return newState;
  }),
  on(loadTransactionReceiptSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.transactionReceipt = payload.transactionReceipt;
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(loadTransactionReceiptErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(clearTransactionReceiptAction, (state, payload) => {
    const newState = { ...state };
    newState.transactionReceipt = null;
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  })
);

export function transactionReducer(state: TransactionState | null, action: Action) {
  return reducer(state, action);
}
